import { AdmissionScope } from '../../types';

/** Valor del select cuando la oferta se ve en los dos ámbitos. */
export const ALL_ADMISSION_SCOPES_VALUE = `${AdmissionScope.OS},${AdmissionScope.OL}`;

/**
 * Traduce los `scopes` guardados de una admisión al valor del select de
 * "Tipo de matrícula" del editor masivo.
 *
 * Un `scopes` vacío o nulo significa "visible en todos los ámbitos" para el
 * backend (el filtro de `getWizardAdmissions` deja pasar la fila cuando está
 * vacío, y el default de la entidad es `["OS","OL"]`), así que se mapea a
 * ambos. Antes caía en `OS`, y como la columna no se edita en la tabla,
 * bastaba con abrir el editor y guardar para degradar la oferta a
 * solo-presencial y hacerla desaparecer del portal online.
 */
export const normalizeScope = (scopes?: AdmissionScope[] | null): string => {
  const hasOs = !!scopes?.includes(AdmissionScope.OS);
  const hasOl = !!scopes?.includes(AdmissionScope.OL);
  if (hasOs && !hasOl) {
    return AdmissionScope.OS;
  }
  if (hasOl && !hasOs) {
    return AdmissionScope.OL;
  }
  return ALL_ADMISSION_SCOPES_VALUE;
};
